import { render, staticRenderFns } from "./PaginationOptionsForm.vue?vue&type=template&id=7576d3b5&scoped=true&lang=pug&"
import script from "./PaginationOptionsForm.vue?vue&type=script&lang=ts&"
export * from "./PaginationOptionsForm.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationOptionsForm.vue?vue&type=style&index=0&id=7576d3b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576d3b5",
  null
  
)

export default component.exports